(function () {
  'use strict';

  function refreshAtlas(atlas) {
    var cards = Array.from(atlas.querySelectorAll('[data-stories-v2-card]'));
    atlas.querySelectorAll('[data-stories-v2-filter]').forEach(function (button) {
      var category = button.dataset.storiesV2Filter;
      var count = cards.filter(function (card) {
        return category === 'all' || card.dataset.category === category;
      }).length;
      var countNode = button.querySelector('b');
      if (countNode) countNode.textContent = String(count);
    });
    setWideCard(atlas);
  }

  function setWideCard(atlas) {
    var firstVisible = true;
    atlas.querySelectorAll('[data-stories-v2-card]').forEach(function (card) {
      card.classList.remove('is-wide');
      if (!card.hidden && firstVisible) {
        card.classList.add('is-wide');
        firstVisible = false;
      }
    });
  }

  function filterAtlas(button) {
    var atlas = button.closest('[data-stories-v2-atlas]');
    if (!atlas) return;
    var category = button.dataset.storiesV2Filter;
    atlas.querySelectorAll('[data-stories-v2-filter]').forEach(function (item) {
      var active = item === button;
      item.classList.toggle('is-active', active);
      item.setAttribute('aria-pressed', String(active));
    });
    atlas.querySelectorAll('[data-stories-v2-card]').forEach(function (card) {
      card.hidden = category !== 'all' && card.dataset.category !== category;
    });
    setWideCard(atlas);
  }

  function openStory(card) {
    var atlas = card.closest('[data-stories-v2-atlas]');
    var dialog = atlas && atlas.querySelector('[data-stories-v2-story-dialog]');
    if (!dialog || typeof dialog.showModal !== 'function') return;
    var sourceImage = card.querySelector('img');
    var dialogImage = dialog.querySelector('[data-stories-v2-story-image]');
    dialogImage.src = sourceImage.currentSrc || sourceImage.src;
    dialogImage.alt = sourceImage.alt;
    dialog.querySelector('[data-stories-v2-story-meta]').textContent =
      card.querySelector('[data-stories-v2-story-label]').textContent.trim() +
      ' / ' +
      card.querySelector('[data-stories-v2-owner]').textContent.trim();
    dialog.querySelector('[data-stories-v2-story-title]').textContent =
      card.querySelector('[data-stories-v2-story-title]').textContent.trim();
    dialog.querySelector('[data-stories-v2-story-body]').textContent =
      card.querySelector('[data-stories-v2-story-source]').textContent.trim();
    dialog.showModal();
  }

  function submissionDialog() {
    return document.querySelector('[data-stories-v2-submit-dialog]');
  }

  function openSubmission(trigger) {
    var dialog = submissionDialog();
    if (!dialog || typeof dialog.showModal !== 'function') return false;
    var type = trigger && trigger.dataset.storiesV2Submit;
    var select = dialog.querySelector('[data-stories-v2-type]');
    if (select && type && Array.from(select.options).some(function (option) { return option.value === type; })) {
      select.value = type;
    }
    if (!dialog.open) dialog.showModal();
    return true;
  }

  function closeDialog(button) {
    var dialog = button.closest('dialog');
    if (dialog) dialog.close();
  }

  document.addEventListener('click', function (event) {
    var filter = event.target.closest('[data-stories-v2-filter]');
    if (filter) {
      filterAtlas(filter);
      return;
    }

    var pin = event.target.closest('[data-stories-v2-pick]');
    if (pin) {
      var atlas = document.querySelector('[data-stories-v2-atlas]');
      var targetFilter = atlas && atlas.querySelector('[data-stories-v2-filter="' + pin.dataset.storiesV2Pick + '"]');
      if (targetFilter) filterAtlas(targetFilter);
      if (atlas) atlas.scrollIntoView({ behavior: 'smooth', block: 'start' });
      return;
    }

    var story = event.target.closest('[data-stories-v2-card]');
    if (story) {
      openStory(story);
      return;
    }

    var submit = event.target.closest('[data-stories-v2-submit]');
    if (submit && openSubmission(submit)) {
      event.preventDefault();
      return;
    }

    var close = event.target.closest('[data-stories-v2-close]');
    if (close) closeDialog(close);
  });

  document.addEventListener('click', function (event) {
    if (event.target instanceof HTMLDialogElement) {
      var bounds = event.target.getBoundingClientRect();
      var outside = event.clientX < bounds.left || event.clientX > bounds.right || event.clientY < bounds.top || event.clientY > bounds.bottom;
      if (outside) event.target.close();
    }
  });

  function initialize(root) {
    root.querySelectorAll('[data-stories-v2-atlas]').forEach(refreshAtlas);
    if (root.querySelector('[data-stories-v2-form-result]')) openSubmission();
  }

  initialize(document);
  document.addEventListener('shopify:section:load', function (event) { initialize(event.target); });
})();
